import axios from "axios";

export const authLogin = async (formData) => {
    return await axios.post(`${window._HOST}login`, formData, {withCredentials: true});
}

export const authLogout = async () => {
    return await axios.get(`${window._HOST}logout`, {withCredentials: true})
}

export const authCekLogin = async () => {
    return await axios.get(`${window._HOST}cekLogin`, {withCredentials: true})
}